import { useEffect, useState } from "react";
import { fetchWithAuth } from "../../api/fetchWithAuth";

export default function CoverageAoiSelect({ onChange }) {
    const [aois, setAoIs] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);

        fetchWithAuth("/api/v1/platform/coverage-aois")
            .then(r => r.json())
            .then(json => {
                // Normalize backend shape explicitly
                setAoIs(Array.isArray(json?.coverage_aois) ? json.coverage_aois : []);
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <select
            className="w-full max-w-md bg-[#0b1220] border border-slate-700 text-slate-100 rounded-md px-3 py-2
                       text-sm shadow-inner focus:outline-none focus:ring-2 focus:ring-orange-500/40
                       focus:border-orange-500/60 disabled:opacity-60"
            onChange={e => onChange(e.target.value)}
            defaultValue=""
            disabled={loading || aois.length === 0}
        >
            <option value="" disabled>
                {loading
                    ? "Loading Coverage AOIs…"
                    : aois.length === 0
                        ? "No Coverage AOIs Found"
                        : "Select Coverage AOI…"}
            </option>

            {aois.map(aoi => (
                <option key={aoi.id} value={aoi.id}>
                    {aoi.name} · {aoi.area_sqmi.toFixed(2)} sq mi
                </option>
            ))}
        </select>
    );
}